import React, { lazy, Suspense } from 'react';

import Loadable from 'react-loadable';
import { useMemoOne } from 'use-memo-one';

import { AnalyticsErrorBoundary } from '@atlaskit/analytics-next';
import { fg } from '@atlaskit/platform-feature-flags';

import { failUfoExperience, UfoExperiences } from '../../ufo-experiences';
import type { ShareToSlackProps } from '../common/types';

import Loading from './Loading';

export default function LazyBulkShareToSlack(props: ShareToSlackProps): React.JSX.Element {
	const WrappedLoadable = useMemoOne(
		() =>
			Loadable<ShareToSlackProps, {}>({
				loader: () =>
					import(
						/* webpackChunkName: "@atlaskit-internal_share-to-slack-clone" */
						'./ShareToSlack'
					),
				loading: () => <Loading />,
			}),
		[],
	);

	const LazyShareToSlack = lazy(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_share-to-slack-clone" */
				'./ShareToSlack'
			),
	);

	return (
		<AnalyticsErrorBoundary
			onError={() => {
				failUfoExperience(UfoExperiences.SLACK_SEGMENT_RENDERED);
				failUfoExperience(UfoExperiences.SLACK_FORM_ENABLED);
			}}
			channel={'shareToSlack'}
			data={{}}
		>
			{fg('puma-1089-r19') ? (
				<Suspense fallback={<Loading />}>
					<LazyShareToSlack {...props} />
				</Suspense>
			) : (
				<WrappedLoadable {...props} />
			)}
		</AnalyticsErrorBoundary>
	);
}
